import React, { Component } from 'react';

import Swiper from 'react-id-swiper';

class Editorial extends Component {
    constructor(props) {
        super(props); this.renderSwiper = this.renderSwiper.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goPrev = this.goPrev.bind(this);
        this.isBeginning = this.isBeginning.bind(this);
        this.isEnd = this.isEnd.bind(this);
        this.state = {
            isBeginning: false, isEnd: false,
            initialSlideDesktop: 0,
            initialSlideTab: 0,
            initialSlideMobile: 0,
            isSet: false,
        };
        this.swiper = null;
    }

    renderSwiper(editorialData, trans) {
        let slides = null;
        // let countToDisplayDesktop = 1;
        // let countToDisplayTab = 1;
        // let countToDisplayMobile = 1;

        let initialSlideDesktop = 0;
        // let initialSlideTab = 0;
        // let initialSlideMobile = 0;
        const params = {
            initialSlide: initialSlideDesktop,
            //pagination: '.swiper-pagination',
            slidesPerView: 'auto',//6,
            paginationClickable: true,
            spaceBetween: 10,
            freeMode: false,
            // containerClass: '',
            runCallbacksOnInit: true,
            observer: true,

        };
        // let arrRound = editorialData;
        if (editorialData) {
            // editorialData = editorialData.Data ? editorialData.Data : [];
            slides = (<Swiper {...params} ref={node => { if (node) this.swiper = node.swiper }} >
                {
                    editorialData.map((element, index) => {
                        let headline = element.headline;
                        let comment = (element.comment);
                        let sharingUrl = (element.sharingUrl);
                        let image = (element.image);
                        let sImageSrc = (image ? image.w3 : '');
                        let eventClick = {
                            onClick: () => {
                                window.open(sharingUrl, '_blank');
                            }
                        };
                        return (<div key={index} className="swiper-slide" {...eventClick}>
                            <div className="si-fnts-block">
                                <div className="si-fnts-image">
                                    <img src={sImageSrc} alt={""}/>
                                </div>
                                <div className="si-fnts-descp">
                                    <div className="si-fnts-txt">{comment}</div>
                                    <div className="si-fnts-ftr"><span className="si-fnts-title">{headline}</span> <span className="si-share-icon-block"><i className="icon-ucl-share"/></span></div>
                                </div>
                            </div>
                        </div>);

                    })
                }
            </Swiper>)
        }


        return slides;

    }

    goNext() {
        if (this.swiper) {
            this.swiper.slideNext();
            this.setState({ isBeginning: this.isBeginning() });
            this.setState({ isEnd: this.isEnd() });
        }
    }

    goPrev() {
        if (this.swiper) {
            this.swiper.slidePrev();
            this.setState({ isBeginning: this.isBeginning() });
            this.setState({ isEnd: this.isEnd() });
        }
    }

    isBeginning() {
        //this.swiper.slideTo(1);
        return this.swiper.isBeginning;
    }

    isEnd() {
        return this.swiper.isEnd;
    }
    componentDidMount() {
        let self = this;
        if (self.swiper) {
            self.swiper.off('slideChangeTransitionEnd').on('slideChangeTransitionEnd', function () {
                self.setState({ isBeginning: self.isBeginning(), isEnd: self.isEnd() }, () => {
                    // self.props.onChangeAactiveIndex(selfSwiper.activeIndex);
                });
            });
            setTimeout(function () {
                if (self.swiper) {
                    //self.swiper.slideTo(0, 0); 
                    self.setState({ isBeginning: self.isBeginning(), isEnd: self.isEnd() });
                }
            }, 0);
        }

        let fetchEditorialCard = self.props.fetchEditorialCard();
        fetchEditorialCard.then(() => {

        }).catch(reason => {
        });
    }

    render() {
        let editorialData = this.props.editorialData;
        if (editorialData) {
            editorialData = editorialData.Data ? editorialData.Data : [];

            let trans = this.props.trans;
            if (editorialData.length) {
                return <div className="si-card si-slider-card">
                    <div className="si-carousal-block">
                        <div className="si-text-title">{trans.fantasyUpdates}</div>
                        <div className="si-carousal-wrapper">
                            <div className="si-carousal-fantasy">
                                <div className="swiper-container swiper-container-horizontal">
                                    <div className="swiper-wrapper">
                                        {
                                            this.renderSwiper(editorialData, trans)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
}

export default Editorial;


// WEBPACK FOOTER //
// ./src/components/home/cards/Editorial.js